"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTON_SIZES = void 0;
var _T_SHIRT_SIZES = require("./T_SHIRT_SIZES");
var BUTTON_SIZES = Object.freeze({
  sm: _T_SHIRT_SIZES.T_SHIRT_SIZES.sm,
  md: _T_SHIRT_SIZES.T_SHIRT_SIZES.md,
  lg: _T_SHIRT_SIZES.T_SHIRT_SIZES.lg
});
exports.BUTTON_SIZES = BUTTON_SIZES;